import React from 'react';
import { Link } from 'react-router-dom';

function ThemeSelector() {
  const themes = [
    { name: 'JavaScript', file: 'questions-js.json', color: 'bg-yellow-400' },
    { name: 'HTML', file: 'questions-html.json', color: 'bg-orange-500' },
    { name: 'CSS', file: 'questions-css.json', color: 'bg-blue-500' },
    { name: 'React', file: 'questions-react.json', color: 'bg-cyan-500' },
    { name: 'UX/UI Design', file: 'questions-uxui.json', color: 'bg-pink-500' },
    { name: 'SEO', file: 'questions-seo.json', color: 'bg-purple-500' },
  ];

  return (
    <div className="w-full">
      <div className="w-full mt-8">
        <h1 className="text-2xl md:text-4xl font-bold text-black text-center mb-12 uppercase tracking-widest pb-4 inline-block">
          SELECT STAGE
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {themes.map((theme) => (
            <Link
              key={theme.name}
              to={`/quiz?file=${theme.file}`}
              className="group border-4 border-black bg-acid hover:bg-black hover:text-acid active:bg-black active:text-acid transform transition-none p-6 text-center cursor-pointer shadow-[8px_8px_0_0_#000] hover:translate-y-1 hover:translate-x-1 hover:shadow-[4px_4px_0_0_#000] active:translate-y-1 active:translate-x-1 active:shadow-[4px_4px_0_0_#000]"
            >
              <div className="text-black group-hover:text-acid group-active:text-acid">
                <h2 className="text-xl md:text-2xl font-bold mb-4 uppercase">{theme.name}</h2>
                <p className="text-xs md:text-sm uppercase tracking-widest border-t-4 border-black group-hover:border-acid group-active:border-acid pt-4">PRESS START</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ThemeSelector;
